module.exports = __webpack_public_path__ + "img/icon_map_7_off_011.4a75a436.png";